import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanChecklist, LoanChecklistResponse } from '../loans/types';
import { checklistMockData } from '../utils/checklist.mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface GetLoanChecklistParams {
  loanId: string;
}

const _mockData = checklistMockData();

const getLoanChecklist: QueryFunction<
  LoanChecklist[],
  ['/loan/checklist-rules', GetLoanChecklistParams]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<LoanChecklistResponse>(
    '/' + queryKey[1].loanId + '/loan-checklist-rules',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.loanChecklistRules ?? [];

  throw new Error('Failed to fetch loan checklist');
};

export default getLoanChecklist;
